<script>
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import ActionFooter from '@components/footer/action-footer.vue';
import CardCircuitBlank from '@components/cards/card-circuit-blank.vue';
import HeroWorkout from '@components/hero/hero-workout.vue';
import { adminPanelMixin } from '@mixins/admin-panel-mixin';
import { circuitModelMixin } from '@mixins/models/circuit-model-mixin';
import { counterMixin } from '@mixins/counter-mixin';
import { helperMixin } from '@mixins/helper-mixin';
import { programMixin } from '@mixins/program-mixin';
import { cleverTapMixin } from '@mixins/cleverTap-mixin';
import {
  authComputed,
  adminPanelComputed,
  adminPanelMethods,
  circuitComputed,
  circuitMethods,
  clientProgramComputed,
  clientProgramMethods,
  mediaComputed,
  mediaMethods,
  programComputed,
  programMethods,
  workoutComputed,
  workoutMethods,
  clientComputed,
  modalComputed,
  modalMethods,
  fitnessTypeComputed,
  fitnessTypeMethods,
} from '@state/helpers';
import moment from 'moment';

export default {
  props: {
    workout: {
      type: Object,
      required: true,
      default: () => {},
    },
    inPanel: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    ActionFooter,
    CardCircuitBlank,
    HeroWorkout,
  },
  mixins: [
    adminPanelMixin,
    counterMixin,
    circuitModelMixin,
    helperMixin,
    programMixin,
    cleverTapMixin,
  ],
  data() {
    return {
      footerWidth: '',
      hasChanges: false,
      image: require('@assets/images/placeholders/exercise.png'),
      initSelectedWorkout: {},
      isWorkoutCustom: false,
      saving: false,
      savingToLibrary: false,
      selectedCircuitIndex: null,
      overActionFooter: false,
      lastSaved: '',
      savedToLibrary: false,
      newUploadedPhotoUrl: '',
    };
  },
  computed: {
    ...adminPanelComputed,
    ...authComputed,
    ...circuitComputed,
    ...clientProgramComputed,
    ...mediaComputed,
    ...programComputed,
    ...workoutComputed,
    ...clientComputed,
    ...modalComputed,
    ...fitnessTypeComputed,
    selectedWorkoutCircuits() {
      return this.selectedWorkout &&
        this.selectedWorkout.circuits &&
        this.selectedWorkout.circuits.length
        ? this.selectedWorkout.circuits.filter(
            (circuit) => !circuit.isNewCircuit
          )
        : [];
    },
    newSelectedWorkoutCircuits() {
      return this.selectedWorkout &&
        this.selectedWorkout.circuits &&
        this.selectedWorkout.circuits.length
        ? this.selectedWorkout.circuits.filter(
            (circuit) => circuit.isNewCircuit
          )
        : [];
    },
    hasCircuits() {
      return (
        this.selectedWorkout &&
        this.selectedWorkout.circuits &&
        this.selectedWorkout.circuits.length
      );
    },
    newCircuitIndex() {
      return this.selectedWorkout &&
        this.selectedWorkout.circuits &&
        this.selectedWorkout.circuits.length > 0
        ? this.selectedWorkout.circuits.length - 1
        : 0;
    },
    selectedDayName() {
      if (this.inPanel) {
        if (this.selectedDay && this.selectedDay.dayName) {
          return this.selectedDay.dayName;
        } else if (this.selectedDay && !this.selectedDay.dayName) {
          return this.$_getDayName(this.selectedDay.dayNumber);
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    selectedDayShortName() {
      const longDayName = this.selectedDayName();
      return longDayName.substring(0, 3);
    },
    isNewWorkout() {
      return (
        this.panelContent && this.panelContent.data.componentLeft.isNewWorkout
      );
    },
    isTrainer() {
      return (
        this.roles && this.roles.length > 0 && this.roles[0] === 'isTrainer'
      );
    },
    allowEditing() {
      if (!this.inPanel) {
        if (
          this.workout &&
          (!this.isTrainer ||
            (this.isTrainer && this.workout.trainer_id !== '0'))
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (!this.isTrainer) {
          return true;
        } else {
          return this.selectedProgram.trainer_id !== '0';
        }
      }
    },
    circuitsLength() {
      return this.selectedWorkout?.circuits.length;
    },
    isPhotoUploaded() {
      return this.hasNewMedia('cover', 'workouts');
    },
  },
  async created() {
    if (!this.allFitnessTypes || !this.allFitnessTypes.length) {
      await this.getAllFitnessTypes({ orgId: this.userOrgId});
    }
    if (!this.allCircuits || !this.allCircuits.length) {
      this.getAllCircuits({
        orgId: this.userOrgId,
        trainerId: this.trainerId ? this.trainerId : '0',
      });
    }
  },
  beforeMount() {
    this.setSelectedWorkout(this.workout);
    this.setAddUniqueId();
  },
  mounted() {
    this.init();
    this.initSelectedWorkout = cloneDeep(this.selectedWorkout);
    window.addEventListener('resize', this.init);
  },
  destroyed() {
    window.removeEventListener('resize', this.init);
  },
  methods: {
    ...adminPanelMethods,
    ...circuitMethods,
    ...clientProgramMethods,
    ...mediaMethods,
    ...programMethods,
    ...workoutMethods,
    ...modalMethods,
    ...fitnessTypeMethods,
    init() {
      if (this.$refs.contentWrapper && this.inPanel) {
        if (this.$refs.contentWrapper.$el.clientWidth > 0) {
          this.footerWidth = this.$refs.contentWrapper.$el.clientWidth;
        }
      }
    },
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
    },
    assignClient() {
      this.$bvModal.show('item-select-modal');
    },
    onUpdateWorkoutProps(workout) {
      this.setSelectedWorkout(workout);
    },
    onShowExerciseList(selectedCircuitIndex = null) {
      this.inPanel
        ? this.expandPanel('ExerciseList', selectedCircuitIndex)
        : this.showAdminPanel('ExerciseList', { selectedCircuitIndex });
    },
    onShowWorkoutList() {
      const data = { panelTitle: 'Add Workout', showWorkoutFilters: true };
      this.showAdminPanel('WorkoutList', data);
    },
    showExerciseListPanelContent(component, selectedCircuitIndex) {
      if (this.inPanel) {
        this.setPanelContent({
          ...this.panelContent,
          data: {
            ...this.panelContent.data,
            componentRight: {
              name: component,
              showPanelDetail: true,
              hideDescription: true,
              showExerciseFilters: true,
              selectedCircuitIndex: selectedCircuitIndex,
            },
          },
        });
      } else {
        this.onShowExerciseList();
      }
    },
    async showCircuitListPanelContent(component) {
      this.setPanelContent({
        ...this.panelContent,
        data: {
          ...this.panelContent.data,
          componentRight: {
            name: component,
            showPanelDetail: true,
            circuits: this.allCircuits
              ? this.allCircuits
              : await this.getAllCircuits({
                  orgId: this.userOrgId,
                  trainerId: this.trainerId ? this.trainerId : '0',
                }),
          },
          panelTitle: 'Add Circuit From Library',
        },
      });
    },
    showWorkoutListPanelContent(component) {
      this.setPanelContent({
        ...this.panelContent,
        data: {
          ...this.panelContent.data,
          panelTitle: `Add Workout to ${this.selectedDayName}`,
          componentRight: {
            name: component,
            showPanelDetail: true,
            showWorkoutFilters: true,
          },
        },
      });
    },
    async expandPanel(component, selectedCircuitIndex = null) {
      switch (component) {
        case 'ExerciseList':
          this.showExerciseListPanelContent(component, selectedCircuitIndex);
          break;
        case 'CircuitForm':
          this.showCircuitListPanelContent(component);
          break;
        case 'WorkoutList':
          this.showWorkoutListPanelContent(component);
          break;
        default:
          break;
      }
    },
    addBlankCircuit() {
      const blankCircuitTemplate = {
        ...this.getCircuitModel(),
        isNewCircuit: true,
        isCustom: true,
        programCircuit_id: null,
        org_id: this.userOrgId,
        trainer_id: this.trainerId,
      };
      this.setAddWorkoutCircuit(blankCircuitTemplate);
    },
    onSelectCircuitItem(circuit) {
      this.setAddWorkoutCircuit(circuit);
      this.setHideAdminPanel();
      this.setSelectedCircuit(null);
    },
    onSelectExerciseItem(exercise) {
      this.setAddWorkoutCircuitExercise({
        exercise: exercise,
        defaultSet: [this.getCircuitExerciseSetModel()],
        circuitIndex: this.selectedCircuitIndex,
      });
      this.setHideAdminPanel();
    },
    onDeselectWorkoutCircuit() {
      this.setSelectedCircuit(null);
    },
    moveWorkoutCircuitUp() {
      const index = this.selectedCircuitIndex;
      if (index > 0) {
        this.setMoveWorkoutCircuitUp({
          circuit: this.selectedCircuit,
          index,
        });
        this.selectedCircuitIndex--;
      }
    },
    moveWorkoutCircuitDown() {
      const index = this.selectedCircuitIndex;
      const circuits = this.selectedWorkout.circuits;
      if (index < circuits.length - 1) {
        this.setMoveWorkoutCircuitDown({
          circuit: this.selectedCircuit,
          index,
        });
        this.selectedCircuitIndex++;
      }
    },
    dupeWorkoutCircuit() {
      this.setAddWorkoutCircuit({
        circuit: this.selectedCircuit,
        index: this.selectedCircuitIndex + 1,
      });
      this.selectedCircuitIndex = null;
      this.setSelectedCircuit(null);
    },
    removeWorkoutCircuit(event) {
      if (event.target.value) {
        this.setRemoveWorkoutCircuit(event.target.value);
        this.selectedCircuitIndex = null;
        this.setSelectedCircuit(null);
      } else {
        const newIndex = this.selectedCircuitIndex;
        this.setRemoveWorkoutCircuit(newIndex);
        this.selectedCircuitIndex = null;
        this.setSelectedCircuit(null);
      }
      if (!this.newSelectedWorkoutCircuits.length) {
        this.setPanelContent({
          ...this.panelContent,
          data: {
            ...this.panelContent.data,
            componentRight: {
              name: 'CircuitForm',
              hideDescription: true,
              showExerciseFilters: true,
            },
          },
        });
      }
    },
    assignMediaUrls() {
      const mediaAssets = {
        coverPhoto: {
          url: this.newUploadedPhotoUrl
            ? this.newUploadedPhotoUrl
            : this.selectedWorkout.mediaAssets
            ? this.selectedWorkout.mediaAssets.coverPhoto.url
            : null,
        },
      };
      return mediaAssets;
    },
    sanitizeCircuits() {
      if (this.hasCircuits) {
        this.selectedWorkout.circuits.forEach((circuit) => {
          delete circuit.isNewCircuit;
        });
      }
    },
    sanitizeWorkouts() {
      this.selectedWorkout.circuits.forEach((circuit) => {
        circuit.exercises.forEach((exercise) => {
          exercise.uniqueKey && delete exercise.uniqueKey;
        });
      });
    },
    compareWorkoutProps() {
      const workoutProps = [
        'label',
        'description',
        'timeToComplete',
        'muscleGroup',
        'exerciseDifficulty',
        'mediaAssets',
      ];
      workoutProps.forEach((prop) => {
        if (
          !isEqual(this.selectedWorkout[prop], this.initialLibraryWorkout[prop])
        ) {
          this.isWorkoutCustom = true;
        }
      });
    },
    comparWorkoutCircuitCount() {
      if (
        this.selectedWorkout.circuits.length !==
        this.initialLibraryWorkout.length
      ) {
        this.isWorkoutCustom = true;
      }
    },
    checkForWorkoutDeviation() {
      if (this.initialLibraryWorkout && this.isLibraryWorkout) {
        this.compareWorkoutProps();
        this.comparWorkoutCircuitCount();
      }
    },
    async buildWorkoutPayload() {
      await this.sanitizeCircuits();
      await this.sanitizeWorkouts();
      return {
        ...this.selectedWorkout,
        org_id: this.userOrgId,
        trainer_id: this.trainerId || '0',
        user_id: '0',
      };
    },
    buildCircuitPayload() {
      const customCircuit = cloneDeep(
        this.selectedWorkout.circuits[this.selectedCircuitIndex]
      );
      delete customCircuit._id;
      return {
        ...customCircuit,
        org_id: this.userOrgId,
        trainer_id: this.trainerId || '0',
        user_id: '0',
      };
    },
    async handleCancel() {
      this.clearMedia();
      this.setSelectedWorkout(cloneDeep(this.initSelectedWorkout));

      const containerWrapper = document.getElementsByClassName(
        'container-wrapper'
      )[0];
      const paneLeft = document.getElementsByClassName('pane-left')[0];
      if (paneLeft && this.inPanel) {
        paneLeft.scroll({
          top: 0,
          behavior: 'smooth',
        });
      }
      if (containerWrapper && !this.inPanel) {
        containerWrapper.scroll({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
    async saveWorkoutToLibrary() {
      if (!this.hasDupeCircuitNames()) {
        if (!this.emptyWorkoutOrCircuit()) {
          this.savingToLibrary = true;
          const payload = await this.buildWorkoutPayload();
          delete payload.isCustom;
          delete payload.programWorkout_id;

          const mediaAssets = await this.assignMediaUrls();

          this.createWorkout({
            workoutObj: {
              ...payload,
              mediaAssets: mediaAssets,
              org_id: this.userOrgId,
              trainer_id: this.trainerId || '0',
              timeToComplete: payload.timeToComplete
                ? parseInt(payload.timeToComplete)
                : 0,
            },
          })
            .then((res) => {
              this.setAddUniqueId(); // for exercises to render
              this.initSelectedWorkout = cloneDeep(this.selectedWorkout);
              this.savingToLibrary = false;
              this.hasChanges = false;
              this.savedToLibrary = true;
              this.lastSaved = `${moment().format(
                'MMMM Do'
              )} at ${moment().format('hh:mm a')}`;

              if (
                this.currentUser &&
                this.currentUser.roles &&
                this.currentUser.roles.isTrainer &&
                res &&
                res.programWorkout
              ) {
                const workout = res.programWorkout._id;
                const trainer = this.trainerEmail;
                this.$_pushCleverTapEvent('Create Library Workout', {
                  workout,
                  trainer,
                });
              }
            })
            .catch((e) => console.log(e));
        }
      }
    },
    async saveCircuitToLibrary() {
      this.savingToLibrary = true;
      const payload = await this.buildCircuitPayload();

      if (!this.hasDupeLibraryCircuitNames(payload)) {
        this.createCircuit({ circuitObj: payload })
          .then((res) => {
            this.savingToLibrary = false;
            this.setSelectedCircuit(null);

            if (
              this.currentUser &&
              this.currentUser.roles &&
              this.currentUser.roles.isTrainer &&
              res &&
              res.programCircuit
            ) {
              const circuit = res.programCircuit._id;
              const trainer = this.trainerEmail;
              this.$_pushCleverTapEvent('Create Library Circuit', {
                circuit,
                trainer,
              });
            }
          })
          .catch((e) => console.log(e));
      }
    },
    async updateProgramWorkout(payload, timeToCompleteSeconds, mediaAssets) {
      await this.setUpdateProgramWorkout({
        ...payload,
        mediaAssets: mediaAssets,
        timeToComplete: timeToCompleteSeconds,
      });

      let programDayPayload;
      if (!this.selectedDay._id) {
        programDayPayload = {
          ...this.selectedDay,
          _id: this.selectedDay.programDay_id,
          trainer_id: this.trainerId || '0',
          org_id: this.userOrgId,
          user_id: '0',
        };
      } else {
        programDayPayload = { ...this.selectedDay };
      }

      this.updateProgramDay({
        programDay: programDayPayload,
      })
        .then(() => {
          this.initSelectedWorkout = cloneDeep(this.selectedWorkout);
          this.saving = false;
          this.hasChanges = false;
          this.setHasChanges(false);
          this.setHideAdminPanel();
        })
        .catch((e) => console.log(e));
    },
    createProgramWorkout(payload, timeToCompleteSeconds, mediaAssets) {
      this.addUpdateWorkoutDay({
        programId: this.selectedProgram._id,
        payload: {
          programDestination: {
            weekNumber: this.selectedWeek.weekNumber,
            dayNumber: this.selectedDay.dayNumber,
          },
          source: {
            type: 'workout',
            programWorkout_id:
              payload.programWorkout_id || this.selectedWorkout._id || null,
            programWorkout: {
              ...payload,
              isCustom:
                this.isWorkoutCustom ||
                !payload.programWorkout_id ||
                !this.selectedWorkout._id,
              mediaAssets: mediaAssets,
              timeToComplete: timeToCompleteSeconds,
            },
          },
        },
      })
        .then(() => {
          this.initSelectedWorkout = cloneDeep(this.selectedWorkout);
          this.saving = false;
          this.hasChanges = false;
          this.savedToLibrary = false;
          this.setHasChanges(false);
          this.setHideAdminPanel();

          if (
            this.currentUser &&
            this.currentUser.roles &&
            this.currentUser.roles.isTrainer &&
            payload &&
            payload.isCustom &&
            this.selectedProgram.user_id !== '0'
          ) {
            const client = this.selectedClient.email;
            const trainer = this.trainerEmail;
            this.$_pushCleverTapEvent('Create Custom Workout', {
              client,
              trainer,
            });
          }
        })
        .catch((e) => console.log(e));
    },
    hasDupeCircuitNames() {
      const circuits = this.selectedWorkout.circuits;
      const circuitWithDupeName = _filter(
        circuits,
        (circuit, i, initCircuitsArr) => {
          return _find(initCircuitsArr, circuit, i + 1);
        }
      )[0];
      if (circuitWithDupeName) {
        this.setNotifyModalContext({
          textMain: `Duplicate Circuit Names`,
          textSecond: `Circuit names must be unique. Try renaming ${circuitWithDupeName.label}.`,
        });
        this.$bvModal.show('notify-modal');
        return true;
      }
    },
    hasDupeLibraryCircuitNames(customCircuit) {
      const circuitWithDupeName = this.allCircuits.find(
        (circuit) => circuit.label === customCircuit.label
      );
      if (circuitWithDupeName) {
        this.setNotifyModalContext({
          textMain: `Duplicate Circuit Names`,
          textSecond: `Circuit names must be unique. Try renaming ${circuitWithDupeName.label}.`,
        });
        this.$bvModal.show('notify-modal');
        this.savingToLibrary = false;
        return true;
      }
    },
    emptyWorkoutOrCircuit() {
      let hasEmptyCircuit = false;
      this.selectedWorkout.circuits.forEach((circuit, index) => {
        if (!circuit.exercises || !circuit.exercises.length > 0) {
          hasEmptyCircuit = true;
        }
      });
      if (!this.hasCircuits || hasEmptyCircuit || this.hasInvalidWorkout) {
        this.setNotifyModalContext({
          textMain: `Error`,
          textSecond: `Workouts can't be empty or have an empty circuit(s)`,
        });
        this.$bvModal.show('notify-modal');
        return true;
      }
    },
    async handleSave() {
      if (!this.hasDupeCircuitNames()) {
        if (!this.emptyWorkoutOrCircuit()) {
          this.saving = true;
          const payload = await this.buildWorkoutPayload();

          const timeToCompleteSeconds =
            typeof payload.timeToComplete === 'string'
              ? this.$_covertToSeconds(payload.timeToComplete)
              : payload.timeToComplete;

          const mediaAssets = await this.assignMediaUrls();

          if (this.inPanel) {
            if (this.isNewWorkout) {
              this.createProgramWorkout(
                payload,
                timeToCompleteSeconds,
                mediaAssets
              );
            } else {
              this.updateProgramWorkout(
                payload,
                timeToCompleteSeconds,
                mediaAssets
              );
            }
          } else {
            this.updateWorkout({
              workoutObj: {
                ...payload,
                mediaAssets: mediaAssets,
                timeToComplete: timeToCompleteSeconds,
              },
            })
              .then((res) => {
                this.setAddUniqueId(); // for exercises to render
                this.initSelectedWorkout = cloneDeep(this.selectedWorkout);
                this.saving = false;
                this.hasChanges = false;
                this.setHasChanges(this.hasChanges);
                this.lastSaved = `${moment().format(
                  'MMMM Do'
                )} at ${moment().format('hh:mm a')}`;
              })
              .catch((e) => console.log(e));
          }
        }
      }
    },
    async handleDelete() {
      this.isLoading = true;
      const programWorkoutId = this.selectedWorkout.programWorkout_id;
      const isCustom = this.selectedWorkout.isCustom || false;
      const programId = this.selectedProgram._id;
      const targetedWeek = this.selectedWeek._id;
      const targetedDay = this.selectedDay._id;
      const payload = {
        programId: programId,
        dayId: targetedDay,
        weekId: targetedWeek,
        workoutId: programWorkoutId,
        isCustom: isCustom,
      };
      if (
        payload.programId &&
        payload.weekId &&
        payload.dayId &&
        (payload.workoutId || payload.isCustom)
      ) {
        await this.deleteWorkoutDay(payload)
          .then((res) => {
            if (res && res.status === 200) {
              this.isLoading = false;
              this.hasChanges = false;
              this.setHideAdminPanel();
              this.setSelectedWorkout(null);

              // if(payload && payload.workoutId) {
              //   const workout = payload.workoutId
              //   const trainer = this.trainerEmail
              //   this.$_pushCleverTapEvent('Create Library Workout', { workout, trainer })
              // }
            } else {
              // TODO: display error adding workout
              setTimeout(() => {
                this.isLoading = false;
              }, 2000);
            }
          })
          .catch((e) => console.log(e));
      }
    },
    onDuplicateWorkout() {
      const payload = cloneDeep(this.workout);
      const label = 'Copy'.concat(' ', payload.label);
      delete payload._id;
      this.createWorkout({
        workoutObj: {
          ...payload,
          label,
          org_id: this.userOrgId,
          trainer_id: this.trainerId,
        },
      })
        .then(async (res) => {
          if (res && res.success) {
            await this.toWorkoutDetail(res.programWorkout);
            this.initSelectedWorkout = await cloneDeep(res.programWorkout);
            await this.setSelectedWorkout(res.programWorkout);
            if (
              this.currentUser &&
              this.currentUser.roles &&
              this.currentUser.roles.isTrainer &&
              res &&
              res.programWorkout
            ) {
              const workout = res.programWorkout._id;
              const trainer = this.trainerEmail;
              this.$_pushCleverTapEvent('Create Library Workout', {
                workout,
                trainer,
              });
            }
          }
        })
        .catch((e) => console.log(e));
    },
    async toWorkoutDetail(workout) {
      this.isMenuOpen = false;
      await this.$router
        .push({
          name: 'workoutDetail',
          params: { id: workout._id, workout: workout },
        })
        .catch(() => {});
    },
    confirmDelete() {
      this.setSelectedItem({
        ...this.selectedWorkout,
        context: 'Workout',
      });
      this.$bvModal.show('confirmation-modal');
    },
  },
  watch: {
    selectedWorkout: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          if (this.hasChanges) {
            this.checkForWorkoutDeviation();
          }
          this.hasChanges = !isEqual(this.initSelectedWorkout, newVal);
          this.setHasChanges(this.hasChanges);
        }
      },
    },
    isAdminPanelActive(val) {
      if (this.inPanel && !val) {
        this.setSelectedWorkout(null);
        this.initSelectedWorkout = null;
        this.hasChanges = false;
        this.saving = false;
        this.setTempPhotoPreview(null);
        this.clearMedia();
      }
      if (this.inPanel && val) {
        this.init();
        this.initSelectedWorkout = cloneDeep(this.selectedWorkout);
        this.setSelectedWorkout(this.workout);
        this.setAddUniqueId();
      }
    },
    circuitsLength(newVal, oldVal) {
      this.circuitsLength && this.setAddUniqueId();
    },
    isPhotoUploaded() {
      if (typeof this.isPhotoUploaded !== 'undefined') {
        this.newUploadedPhotoUrl = this.hasNewMedia('cover', 'workouts')
          ? this.hasNewMedia('cover', 'workouts').publicUrl
          : this.newUploadedPhotoUrl;
        this.setSelectedWorkout({
          ...this.selectedWorkout,
          mediaAssets: {
            coverPhoto: {
              url: this.newUploadedPhotoUrl,
            },
          },
        });
      }
    },
  },
};
</script>

<template>
  <div :class="['workout-detail', { 'in-panel': inPanel }]">
    <HeroWorkout
      ref="contentWrapper"
      v-if="selectedWorkout"
      :inPanel="inPanel"
      :workout="selectedWorkout"
      :initSelectedWorkout="initSelectedWorkout"
      type="light"
      @update-workout-props="onUpdateWorkoutProps"
      :allowEditing="allowEditing"
    />

    <div
      class="set-card-container"
      :style="[!inPanel ? { padding: '4rem 3.7rem 0' } : '']"
    >
      <span v-if="hasCircuits">
        <CardCircuitBlank
          v-for="(circuit, i) in selectedWorkout.circuits"
          class="workout-circuit"
          :key="i"
          :circuit="circuit"
          :circuitIndex="i"
          :selectedCircuitIndex="selectedCircuitIndex"
          @on-select-circuit="(index) => (selectedCircuitIndex = index)"
          @show-exercise-list="onShowExerciseList"
          :overActionFooter="overActionFooter"
          :inPanel="inPanel"
          @remove-blank-circuit="removeWorkoutCircuit"
          :allowEditing="allowEditing"
        />
      </span>

      <div
        :class="['add-new-circuit-wrapper', { 'has-circuits': hasCircuits }]"
      >
        <div v-if="!inPanel && allowEditing">
          <BaseButton
            type="button"
            class="btn-primary btn-round"
            @click="addBlankCircuit"
          >
            <BaseIcon name="plus" /> Create Circuit
          </BaseButton>
          <span class="btn-divider">or</span>
          <BaseButton
            type="button"
            class="btn-secondary btn-round"
            @click="
              inPanel
                ? expandPanel('CircuitForm')
                : showAdminPanel('CircuitForm', null, null)
            "
          >
            Add Circuit From Library
          </BaseButton>
        </div>

        <div v-if="inPanel && allowEditing">
          <BaseButton
            type="button"
            class="btn-primary btn-round"
            @click="addBlankCircuit"
          >
            <BaseIcon name="plus" /> Create Circuit
          </BaseButton>
          <span class="btn-divider">or</span>
          <BaseButton
            type="button"
            class="btn-secondary btn-round"
            @click="expandPanel('CircuitForm')"
          >
            Add Circuit From Library
          </BaseButton>
        </div>
      </div>

      <div
        class="add-new-workout-wrapper"
        v-if="!hasCircuits && (inPanel || (!inPanel && allowEditing))"
      >
        <h2>Create a Workout</h2>
        <p>
          Create a workout for your client. A workout is made up of circuits. A
          circuit is made up of one or more exercises. If you have already saved
          some workouts, you can build your library.
        </p>
        <BaseButton
          v-if="!inPanel"
          type="button"
          class="btn-secondary btn-round"
          @click="inPanel ? expandPanel('WorkoutList') : onShowWorkoutList()"
        >
          Use Workout From Library
        </BaseButton>
      </div>
      <div
        class="add-new-workout-wrapper"
        v-if="!hasCircuits && !inPanel && !allowEditing"
      >
        <h2>Workout Is Empty</h2>
        <p>
          It looks like you caught us in the middle of a work in progress. This
          workout will be done soon. Check back later for more inspiration.
        </p>
      </div>
    </div>

    <ActionFooter
      v-if="
        (!inPanel || (inPanel && allowEditing && isAdminPanelActive)) &&
          !selectedCircuit &&
          ((allowEditing && hasCircuits) ||
            (!allowEditing && hasCircuits) ||
            (allowEditing && !hasCircuits))
      "
      :style="
        `width: ${footerWidth}px; margin-left: ${
          $route.name === 'programDetail' ? 0 : 3
        }rem;`
      "
      :selected-item="selectedWorkout"
      item-type="Workout"
      color="black"
    >
      <span
        v-if="
          allowEditing &&
            !hasChanges &&
            lastSaved &&
            !savingToLibrary &&
            !saving &&
            !hasNewMedia('cover', 'workouts')
        "
        class="saved-status"
        slot="actionState"
      >
        Last Saved: {{ lastSaved }}
      </span>
      <span
        v-if="
          (allowEditing &&
            !lastSaved &&
            !hasChanges &&
            !hasNewMedia('cover', 'workouts') &&
            !isLibraryWorkout) ||
            (isLibraryWorkout && !isWorkoutCustom && !hasChanges) ||
            (isLibraryWorkout &&
              !isWorkoutCustom &&
              !hasNewMedia('cover', 'workouts') &&
              !savingToLibrary &&
              !saving &&
              !isNewWorkout)
        "
        class="saved-status"
        slot="actionState"
        >No changes</span
      >
      <span
        v-if="
          (allowEditing && hasChanges) ||
            (hasNewMedia('cover', 'workouts') && !isLibraryWorkout) ||
            (isLibraryWorkout && !isWorkoutCustom && hasChanges) ||
            (isLibraryWorkout &&
              !isWorkoutCustom &&
              hasNewMedia('cover', 'workouts') &&
              !savingToLibrary &&
              !saving)
        "
        slot="secondaryAction"
      >
        Not saved
        <span class="link-deselect" @click="handleCancel">
          Cancel
        </span>
      </span>
      <span v-if="!allowEditing" class="saved-status" slot="actionState">
        Duplicate to make changes
      </span>
      <BaseButton
        v-if="inPanel"
        type="button"
        class="btn-primary btn-clear"
        :disabled="
          (!hasChanges &&
            !hasNewMedia('cover', 'workouts') &&
            !isLibraryWorkout) ||
            (isLibraryWorkout && !isWorkoutCustom && !hasChanges) ||
            (isLibraryWorkout &&
              !isWorkoutCustom &&
              !hasNewMedia('cover', 'workouts'))
        "
        :style="{
          opacity:
            (!hasChanges &&
              !hasNewMedia('cover', 'workouts') &&
              !isLibraryWorkout) ||
            (isLibraryWorkout && !isWorkoutCustom && !hasChanges) ||
            (isLibraryWorkout &&
              !isWorkoutCustom &&
              !hasNewMedia('cover', 'workouts')) ||
            savingToLibrary
              ? 0.6
              : 1,
        }"
        @click="saveWorkoutToLibrary"
      >
        <BaseIcon v-if="savingToLibrary" name="sync" spin />
        <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!savingToLibrary" v-bind:class="'icon-save'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.023 2.871a.72.72 0 00-1.438.048v4.644c0 .007.002.015.005.022l2.041 4.52c.017.056.034.107.051.153.421 1.093.652 3.82.652 3.82l4.462-.549.64-3.677-.002-.037 1.983-4.28a.052.052 0 00.005-.022V3.002a.802.802 0 00-1.602-.054l-.266 3.991a.05.05 0 01-.005.02l-.935 1.89c-.037.053-.075.121-.115.208l-.031.09-.17.344c-.79 1.267-2.912 1.459-3.944-.398L8.3 6.958a.05.05 0 01-.006-.019l-.271-4.068zm4.988 4.954c0 .897-.688 1.625-1.537 1.625-.85 0-1.538-.728-1.538-1.625 0-.898.688-1.625 1.538-1.625.849 0 1.537.727 1.537 1.625z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M.946 1a1 1 0 011-1h1.785a1 1 0 011 1v2H17.98V1a1 1 0 011-1h1.786a1 1 0 011 1v2h.196a.75.75 0 110 1.5h-.196V7a1 1 0 01-1 1h-1.786a1 1 0 01-1-1V4.5H4.731V7a1 1 0 01-1 1H1.946a1 1 0 01-1-1V4.5H.75a.75.75 0 010-1.5h.196V1zM11.832 17.534l3.597.98-.262 4.66a.915.915 0 001.819.192l.983-6.332a.084.084 0 00-.047-.089l-4.126-1.909-3.866.846-.494-.29S3.832 22.216 3.33 22.79c-.503.575.464 1.854 1.41 1.057.812-.683 5.712-5.077 7.092-6.314z" fill="#fff"/></svg>
        Save as New Workout
      </BaseButton>
      <span class="divider-vertical">&nbsp;</span>
      <BaseButton
        v-if="inPanel"
        type="button"
        class="btn-primary btn-clear"
        @click="handleDelete"
      >
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
        Delete
      </BaseButton>

      <span class="divider-vertical" v-if="inPanel">&nbsp;</span>
      <BaseButton
        v-if="inPanel && isNewWorkout"
        type="button"
        class="btn-primary btn-clear"
        :disabled="
          (!savedToLibrary &&
            !hasChanges &&
            !hasNewMedia('cover', 'workouts')) ||
            (!savedToLibrary &&
              !hasChanges &&
              !hasNewMedia('cover', 'workouts'))
        "
        :style="{
          opacity:
            (!savedToLibrary &&
              !hasChanges &&
              !hasNewMedia('cover', 'workouts')) ||
            (!savedToLibrary &&
              !hasChanges &&
              !hasNewMedia('cover', 'workouts')) ||
            saving
              ? 0.6
              : 1,
        }"
        @click="handleSave"
      >
        <BaseIcon v-if="saving" name="sync" spin />
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!saving" v-bind:class="'icon-calendar'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.4 0v1.2H3.6V0H2.4v1.2h-.6c-.666 0-1.194.54-1.194 1.2L.6 10.8c0 .66.534 1.2 1.2 1.2h8.4c.66 0 1.2-.54 1.2-1.2V2.4c0-.66-.54-1.2-1.2-1.2h-.6V0H8.4zM9 6.6H6v3h3v-3zm-7.2 4.2h8.4V4.2H1.8v6.6z" fill="#fff"/></svg>
        Add Workout to {{ selectedDayName }}
      </BaseButton>
      <BaseButton
        v-if="inPanel && !isNewWorkout"
        type="button"
        class="btn-primary btn-clear"
        :disabled="!hasChanges && !hasNewMedia('cover', 'workouts')"
        :style="{
          opacity:
            (!hasChanges && !hasNewMedia('cover', 'workouts')) || saving
              ? 0.6
              : 1,
        }"
        @click="handleSave"
      >
        <BaseIcon v-if="saving" name="sync" spin />
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!saving" v-bind:class="'icon-calendar'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.222 0H1.89C.84 0 0 .85 0 1.889V15.11C0 16.15.84 17 1.889 17H15.11c1.04 0 1.89-.85 1.89-1.889V3.778L13.222 0zM8.5 15.111a2.83 2.83 0 01-2.833-2.833A2.83 2.83 0 018.5 9.444a2.83 2.83 0 012.833 2.834A2.83 2.83 0 018.5 15.11zM1.889 5.667h9.444V1.889H1.89v3.778z" fill="#fff"/></svg>
        Save Workout
      </BaseButton>
      <BaseButton
        v-if="!inPanel && allowEditing"
        type="button"
        class="btn-primary btn-clear"
        @click="confirmDelete"
      >
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
        Delete Workout
      </BaseButton>
      <span class="divider-vertical" v-if="!inPanel">&nbsp;</span>
      <BaseButton
        v-if="!inPanel && allowEditing"
        type="button"
        class="btn-primary btn-clear"
        :disabled="!hasChanges && !hasNewMedia('cover', 'workouts')"
        :style="{
          opacity:
            (!hasChanges && !hasNewMedia('cover', 'workouts')) || saving
              ? 0.6
              : 1,
        }"
        @click="handleSave"
      >
        <BaseIcon v-if="saving" name="sync" spin />
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!saving" v-bind:class="'icon-save'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.222 0H1.89C.84 0 0 .85 0 1.889V15.11C0 16.15.84 17 1.889 17H15.11c1.04 0 1.89-.85 1.89-1.889V3.778L13.222 0zM8.5 15.111a2.83 2.83 0 01-2.833-2.833A2.83 2.83 0 018.5 9.444a2.83 2.83 0 012.833 2.834A2.83 2.83 0 018.5 15.11zM1.889 5.667h9.444V1.889H1.89v3.778z" fill="#fff"/></svg>
        Save Workout
      </BaseButton>
      <BaseButton
        v-if="!inPanel && !allowEditing"
        type="button"
        class="btn-primary btn-clear"
        @click="onDuplicateWorkout"
      >
        <BaseIcon v-if="saving" name="sync" spin />
        <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!saving" v-bind:class="'icon-save'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
        Duplicate
      </BaseButton>
    </ActionFooter>

    <ActionFooter
      v-if="selectedCircuit"
      :style="
        `width: ${footerWidth}px; margin-left: ${
          $route.name === 'programDetail' ? 0 : 3
        }rem;`
      "
      :selected-item="selectedCircuit"
      item-type="Circuit"
    >
      <span slot="secondaryAction">
        Not Saved
      </span>
      <span slot="secondaryAction">
        <span
          class="action-title link-deselect"
          @click="onDeselectWorkoutCircuit"
        >
          Deselect
        </span>
      </span>
      <span
        @mouseover="() => (overActionFooter = true)"
        @mouseleave="() => (overActionFooter = false)"
      >
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          :disabled="
            (!hasChanges &&
              !hasNewMedia('cover', 'workouts') &&
              !isLibraryWorkout) ||
              (isLibraryWorkout && !isWorkoutCustom && !hasChanges) ||
              (isLibraryWorkout &&
                !isWorkoutCustom &&
                !hasNewMedia('cover', 'workouts'))
          "
          :style="{
            opacity:
              (!hasChanges &&
                !hasNewMedia('cover', 'workouts') &&
                !isLibraryWorkout) ||
              (isLibraryWorkout && !isWorkoutCustom && !hasChanges) ||
              (isLibraryWorkout &&
                !isWorkoutCustom &&
                !hasNewMedia('cover', 'workouts')) ||
              savingToLibrary
                ? 0.6
                : 1,
          }"
          @click="saveCircuitToLibrary"
        >
          <BaseIcon v-if="savingToLibrary" name="sync" spin />
          <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!savingToLibrary" v-bind:class="'icon-save'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0h6v2H6V0zm2 13V7h2v6H8zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 009 3a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM2 12c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7z" fill="#000"/></svg>
          Save to Library
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="moveWorkoutCircuitUp"
        >
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-arrow'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.178 7.019l5.196-4.935 5.196 4.935" stroke="#fff" stroke-width="2"/><path d="M6.44 3.916v10" stroke="#fff" stroke-width="2" stroke-linecap="square"/></svg>
          Move Up
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="moveWorkoutCircuitDown"
        >
          <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-arrow'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.609 7.981l5.195 4.935L12 7.981" stroke="#fff" stroke-width="2"/><path d="M6.871 11.084v-10" stroke="#fff" stroke-width="2" stroke-linecap="square"/></svg>
          Move Down
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="removeWorkoutCircuit"
        >
          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
          Delete
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="dupeWorkoutCircuit"
        >
          <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
          Duplicate
        </BaseButton>
      </span>
    </ActionFooter>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.workout-detail {
  .container-wrapper {
    padding-bottom: 20rem;

    .set-card-container {
      height: auto;
      padding: 4rem 3.7rem;
    }
  }

  .add-new-circuit-wrapper {
    display: flex;
    justify-content: center;
    margin: 2rem 0 5rem;

    &.has-circuits {
      justify-content: flex-start;
    }

    .btn-gray {
      background-color: $color-medium-gray;
    }

    .btn-divider {
      font-size: 1.6rem;
      font-weight: 800;
      line-height: 2.2rem;
      margin: 0 1.6rem;
    }
  }

  .add-new-workout-wrapper {
    background-color: white;
    border-radius: $base-border-radius-lg;
    box-shadow: 0 0.4rem 0.88rem rgba($color-black-wo-rgb, 0.08);
    margin: 0 auto;
    padding: 4rem 6rem;
    text-align: center;
    width: 58.2rem;

    h2 {
      font-size: 2.8rem;
      margin-bottom: 2rem;
    }

    .button {
      margin-top: 3rem;
    }
  }

  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep .workout-circuit {
    .exercise-title ~ .row {
      padding-left: 0;
    }
    .rep-controls {
      margin: 0 auto;
    }

    .exercise-set-details {
      .exercise-set-details-header {
        padding-bottom: 1rem;
        text-align: center;

        .col {
          padding: 0;
        }
      }
    }

    .card-circuit-header {
      .rep-counter {
        .rep-icon-wrapper {
          background-color: rgba($color-medium-gray-wo-rgb, 0.3);

          &:hover {
            background-color: rgba($color-medium-gray-wo-rgb, 0.5);
          }
        }
      }
    }

    .set-controls {
      padding: 0;

      .set-num {
        margin: 0 1rem;
      }
    }
  }

  &.in-panel {
    .hero {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .set-card-container {
      background-color: $color-off-white;
      height: auto;
      padding: 2rem 0.5rem 30rem;

      @include media('xxxl', null) {
        padding: 2rem 3rem 30rem;
      }
    }

    .action-footer {
      @include media('xxxl', null) {
        padding: 1rem 1.8rem;
      }
    }

    .action-footer-wrapper {
      width: 65%;
      @include media('xl', null) {
        width: 89.8%;

        .btn-primary {
          padding-left: 1.2rem;
          padding-right: 1.2rem;
        }
      }

      @include media('xxl', null) {
        width: 89.8%;
      }

      @include media('xxl', 'ipad') {
        width: 75.5%;
      }

      @include media('xxl', 'ipad-md') {
        width: 75.5%;
      }

      @include media('xxxl', null) {
        width: 65%;

        .btn-primary {
          padding-left: 2.4rem;
          padding-right: 2.4rem;
        }
      }
    }

    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
      .action-footer-wrapper {
        width: 89.8%;
      }
    }
  }
}
</style>
